import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stausCandidatMission',
})
export class StausCandidatMissionPipe implements PipeTransform {
  transform(value: any): string {
    switch (value) {
      case 'PENDING':
        return 'En attente';
      case 'COMFIRMED':
        return 'Confirmée, vous devez signer le contrat';
      case 'VALIDATED':
        return 'Validée';
      case 'INVALIDATED':
        return 'Non Validée';
      default:
        return 'N/A';
    }
  }
}
